import "app/config/global";

import { createTheme, responsiveFontSizes } from "@material-ui/core";

const Theme = responsiveFontSizes(createTheme({
    typography: {
        default: {
            fontFamily: globalThis.config.fonts.families.regular,
            fontSize: globalThis.config.fonts.sizes.small,
        },
        xxsmallBold: {
            fontFamily: globalThis.config.fonts.families.bold,
            fontSize: globalThis.config.fonts.sizes.xxsmall,
        },
        xxsmallLight: {
            fontFamily: globalThis.config.fonts.families.light,
            fontSize: globalThis.config.fonts.sizes.xxsmall,
        },
        xxsmallMedium: {
            fontFamily: globalThis.config.fonts.families.medium,
            fontSize: globalThis.config.fonts.sizes.xxsmall,
        },
        xsmall: {
            fontFamily: globalThis.config.fonts.families.regular,
            fontSize: globalThis.config.fonts.sizes.xsmall,
        },
        xsmallBold: {
            fontFamily: globalThis.config.fonts.families.bold,
            fontSize: globalThis.config.fonts.sizes.xsmall,
        },
        xsmallLight: {
            fontFamily: globalThis.config.fonts.families.light,
            fontSize: globalThis.config.fonts.sizes.xsmall,
        },
        small: {
            fontFamily: globalThis.config.fonts.families.regular,
            fontSize: globalThis.config.fonts.sizes.small,
        },
        smallLight: {
            fontFamily: globalThis.config.fonts.families.light,
            fontSize: globalThis.config.fonts.sizes.small,
        },
        smallBold: {
            fontFamily: globalThis.config.fonts.families.bold,
            fontSize: globalThis.config.fonts.sizes.small,
        },
        smedium: {
            fontFamily: globalThis.config.fonts.families.regular,
            fontSize: globalThis.config.fonts.sizes.smedium,
        },
        medium: {
            fontFamily: globalThis.config.fonts.families.regular,
            fontSize: globalThis.config.fonts.sizes.medium,
        },
        mediumBold: {
            fontFamily: globalThis.config.fonts.families.bold,
            fontSize: globalThis.config.fonts.sizes.medium,
        },
        mediumLight: {
            fontFamily: globalThis.config.fonts.families.light,
            fontSize: globalThis.config.fonts.sizes.medium,
        },
        large: {
            fontFamily: globalThis.config.fonts.families.regular,
            fontSize: globalThis.config.fonts.sizes.large,
        },
        largeBold: {
            fontFamily: globalThis.config.fonts.families.bold,
            fontSize: globalThis.config.fonts.sizes.large,
        },
        largeLight: {
            fontFamily: globalThis.config.fonts.families.light,
            fontSize: globalThis.config.fonts.sizes.large,
        },
        xlarge: {
            fontFamily: globalThis.config.fonts.families.regular,
            fontSize: globalThis.config.fonts.sizes.xlarge,
        },
        xlargeBold: {
            fontFamily: globalThis.config.fonts.families.bold,
            fontSize: globalThis.config.fonts.sizes.xlarge,
        },
        xlargeLight: {
            fontFamily: globalThis.config.fonts.families.light,
            fontSize: globalThis.config.fonts.sizes.xlarge,
        },
        xxlarge: {
            fontFamily: globalThis.config.fonts.families.regular,
            fontSize: globalThis.config.fonts.sizes.xxlarge,
        },
        xxlargeBold: {
            fontFamily: globalThis.config.fonts.families.bold,
            fontSize: globalThis.config.fonts.sizes.xxlarge,
        },
        xxlargeLight: {
            fontFamily: globalThis.config.fonts.families.light,
            fontSize: globalThis.config.fonts.sizes.xxlarge,
        },
        xxxlarge: {
            fontFamily: globalThis.config.fonts.families.regular,
            fontSize: globalThis.config.fonts.sizes.xxxlarge,
        },
        htmlFontSize: 12,
    },

    palette: {
        primary: {
            light: globalThis.config.colors.gray5,
            main: globalThis.config.colors.black,
            dark: globalThis.config.colors.black,
            contrastText: globalThis.config.colors.white,
        },
        secondary: {
            light: globalThis.config.colors.white,
            main: globalThis.config.colors.white,
            dark: globalThis.config.colors.gray2,
            contrastText: globalThis.config.colors.black,
        },
    },
}));

export default Theme;
